import { Lead, LeadEmail } from '../../../../types'
import { ILeadRepository } from '../../infrastructure/repositories'

export interface UpdateLeadData {
 name: string
 phones: Array<{
 phone: string
 type: string
 isPrimary: boolean
 isWhatsApp: boolean
 }>
 emails?: LeadEmail[]
 document?: string
 message?: string
 source?: string
 assignedTo?: string
 vehicleInterests?: Array<{
 vehicleId: string
 priority: number
 notes?: string
 }>
 notes?: string
 preferences?: Record<string, any>
}

export class UpdateLeadUseCase {
 constructor(private leadRepository: ILeadRepository) {}

 async execute(id: string, data: UpdateLeadData): Promise<Lead> {
 if (!id) {
 throw new Error('ID do lead é obrigatório')
 }

 if (!data.name?.trim()) {
 throw new Error('Nome é obrigatório')
 }

 if (!data.phones || data.phones.length === 0) {
 throw new Error('Pelo menos um telefone é obrigatório')
 }

 return this.leadRepository.update(id, data as any)
 }
}

